import { rgb, StandardFonts } from 'pdf-lib';

export const cacPdf = async (pdfDoc, data) => {
  // Replace [name]
  const page = pdfDoc.getPages()[0];
  const { width, height } = page.getSize();

  const font = await pdfDoc.embedFont(StandardFonts.Helvetica, {
    subset: true,
    features: { liga: false },
  });

  page.drawRectangle({
    x: 72, // X position of the background
    y: 375, // Y position of the background
    width: width - 140, // Width of the background box (adjust as needed)
    height: 330, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });
  const vtc = `During your employment, the ${data.DSP_TRADENAME} may want to communicate with you relating to your job via automated and/or prerecorded telephone calls and/or text messages. By accepting and maintaining employment with the ${data.DSP_TRADENAME}, you consent to receiving automated and/or prerecorded calls and/or text messages at any number you provide to the ${data.DSP_TRADENAME}. You consent to receiving such  communications sent from the ${data.DSP_TRADENAME} and any ${data.DSP_TRADENAME} employees, agents or vendors who are authorized to call and send text messages on behalf of the ${data.DSP_TRADENAME}. Message frequency varies. Message and data rates may apply.\n \nTo ensure the ${data.DSP_TRADENAME} has your current information on file, you are required to promptly notify ${data.DSP_EMAIL} of any change in your telephone number(s). This consent covers any and all updated telephone numbers.\n \nYou have the right to revoke your consent at any time by emailing ${data.DSP_EMAIL} and stating that you wish to revoke your consent to receiving automated calls or texts on your personal mobile telephone.\n \nI understand that my consent is not a condition of employment. I understand that if I opt-out of receiving prerecorded or autodialed telephone calls or text messages, the ${data.DSP_TRADENAME} may not be able to communicate with me about important company and employment-related information both for emergency and nonemergency situations.\n \nI agree to notify ${data.DSP_TRADENAME} within 24 hours, or as soon as possible, if I change my telephone number(s).`;

  // const textWidth = font.widthOfTextAtSize(vtc, 14);
  // const textHeight = font.heightAtSize(14);

  page.drawText(vtc, {
    x: 72, // X position of the placeholder
    y: 680, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 14,
    font,
    maxWidth: width / 1.2,

    // letterSpacing: 0.5,
  });
  /////

  page.drawText(data.SUFFIX + data.NAME, {
    x: 72, // X position of the placeholder
    y: height - 520, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 15,
  });
  page.drawText(data.DATE, {
    x: 290, // X position of the placeholder
    y: height - 450, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 15,
  });

  // //////

  if (data.SIGNATURE) {
    data.SIGNATURE.forEach((pathString) => {
      page.drawSvgPath(pathString, {
        x: 72,
        y: height - 410,
        // color,
        // borderColor: color,
        borderWidth: 5,
        scale: 0.3,
      });
    });
  }
};
